export default [
    { name:'home', path:'/home',  component: () => import('@/views/home') },
    { name:'about', path:'/about',  component: () => import('@/views/home/page/aboutUs') },
    { name:'platform', path:'/platform',  component: () => import('@/views/home/page/onlineLearning') },
    { name:'faq', path: '/faq', component: () => import('@/views/home/page/faq') },
    { name:'helps', path: '/helps', component: () => import('@/views/home/page/helps') },
    { name:'contact', path:'/contact',  component: () => import('@/views/home/page/contactUs') },
    { name:'sitemap', path:'/sitemap',  component: () => import('@/views/home/page/sitemap') },
    { name:'privacy', path:'/privacy',  component: () => import('@/views/home/page/privacyPolicyStatement') },
    { name:'disclaimer', path: '/disclaimer', component: () => import('@/views/home/page/disclaimer') }, 
    { name:'refund', path: '/refund', component: () => import('@/views/home/page/refundPolicy') },
]